import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { Button, Row, Col } from "react-bootstrap";
import UncontrolledExample from "./carousel";

function Main() {
  let navigate = useNavigate();
  return (
    <div style={{ width: "100%", padding: "1rem" }}>
      <UncontrolledExample />

      <header className="mt-5 mb-5 text-center ml-3 mr-3">
        <h1
          className="mb-5 mb-5"
          style={{ fontSize: "2.1rem", lineHeight: "50px" }}
        >
          <span>더 실력있는 클라이머가 되고 싶다면?</span>
        </h1>

        <p style={{ fontSize: "1.2rem" }}>
          트레이닝만이 여러분의 클라이밍 실력을 향상시켜줍니다.
        </p>
        <p style={{ fontSize: "1.2rem" }}>
          클라이밍을 더 잘하고 싶다면, 국가대표 출신의 센터장님과, 수십년 경력의
          클라이머 선배님들이 함께하는 파워 클라이밍 센터에서 실력을
          향상시켜보세요!
        </p>
      </header>
      <div
        style={{
          backgroundColor: "rgba(0,0,0, 0.7)",
          height: "1rem",
          width: "10rem",
          margin: "0 auto",
          marginTop: "5rem",
          marginBottom: "5rem",
          borderRadius: "1rem",
        }}
      ></div>
      <div style={{ textAlign: "center" }}>
        <img
          src="power5.jpg"
          alt="강습"
          style={{ margin: "2rem", borderRadius: "1rem", width: "80%" }}
        />
      </div>
      <div className="mt-5 mb-5 text-center">
        <h1 className="mb-5 mb-5">
          <span
            style={{
              fontSize: "2.1rem",
              lineHeight: "50px",
              textAlign: "center",
            }}
          >
            혹시 클라이밍이 처음이신가요?
          </span>
        </h1>

        <p style={{ fontSize: "1.2rem" }}>
          파워 클라이밍 센터에는 국가대표 출신 센터장님은 물론, 수십년 등반
          경력의 선배님들과 선수 출신 클라이머들이 다수 존재합니다.
        </p>
        <p style={{ fontSize: "1.2rem" }}>
          다양한 난이도의 지구력 벽에서 여러분의 클라이밍 실력을 단계적으로
          쌓아보세요.
        </p>
      </div>
      <div
        style={{
          backgroundColor: "rgba(0,0,0, 0.7)",
          height: "1rem",
          width: "10rem",
          margin: "0 auto",
          marginTop: "5rem",
          marginBottom: "5rem",
          borderRadius: "1rem",
        }}
      ></div>
      <div>
        <div className="mt-5 mb-5 text-center">
          <h1 className="mb-5 mb-5">
            <span
              style={{
                fontSize: "45px",
                lineHeight: "50px",
                textAlign: "center",
              }}
            >
              센터장님을 소개합니다
            </span>
          </h1>
        </div>
        <div>
          <Row xs={1} md={2} className="g-4">
            <Col>
              <img
                alt="센터장님"
                src="centerjang.jpg"
                style={{ width: "100%", borderRadius: "1rem" }}
              ></img>
            </Col>
            <Col>
              <div
                style={{
                  border: "0.2rem solid black",
                  borderRadius: " 1rem",
                  textAlign: "center",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    margin: "1rem",
                    padding: "1rem",
                    fontSize: "2rem",
                    fontWeight: "bold",
                  }}
                >
                  센터장 이정옥
                </div>
                <div
                  style={{
                    margin: "1rem",
                    padding: "1rem",
                    fontSize: "1.5rem",
                  }}
                >
                  대한민국 유일 암벽, 빙벽 동시 국가대표 출신. 유학산 개척과
                  연경 도약대 개척을 함께하였으며 현재는 파워 클라이밍 센터
                  운영중
                </div>
                <div style={{ textAlign: "center", margin: "1rem" }}>
                  <Button
                    onClick={() => {
                      navigate("/centerjang");
                    }}
                    variant="primary"
                  >
                    센터장 소개
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default Main;
